import { combineReducers } from 'redux'

import create from './Create/state'
import accept from './AcceptInvitation/state'
import join from './Join/state'

export default combineReducers({
  create,
  join,
  accept,
})
